export default __webpack_public_path__ + "static/media/EverydaySans-Medium.762772de.otf";